import { PropsWithChildren, ButtonHTMLAttributes } from 'react';

import './styles.scss';

export enum Preset {
  None = '',
  Primary = 'primary',
  Secondary = 'secondary',
  Danger = 'danger',
  Negative = 'negative'
}

export interface IProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> {
  preset?: Preset;
  onPress?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export default function Button({
  className = '',
  type = 'button',
  disabled = false,
  onPress,
  preset = Preset.None,
  ...remainingProps
}: PropsWithChildren<IProps>) {
  const mergedClassName = ['button', className, preset, disabled && 'disabled']
    .filter(Boolean)
    .join(' ');

  return (
    <button
      className={mergedClassName}
      type={type}
      disabled={disabled}
      onClick={onPress}
      {...remainingProps}
    />
  );
}
